<template>
    <div class="qrcode-overview" v-if="isQrCodePay || isQrCodeDebit">
        <div class="qrcode-overview__container">
            <div class="qrcode-overview__info">
                <div class="qrcode-overview__icon">
                    <img :src="getPaymentTypeIcon" alt="QR Code" tabindex="0" />
                </div>

                <span class="qrcode-overview__description" tabindex="0">
                    {{ selectedPaymentMethod.Description }}
                </span>
            </div>

            <div class="qrcode-overview__price" tabindex="0">
                <p v-if="isQrCodeDebit">
                    {{ 1 }}x
                    <span v-text="$ml.get('of')" />
                    R$ {{ installmentPrice }}
                </p>
                <p v-else>
                    {{ installments }}x
                    <span v-text="$ml.get('of')" />
                    R$ {{ installmentPrice }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import PaymentTypes from '@/models/PaymentTypes';
import { mapGetters } from 'vuex';
import QrCodePayIcon from '@/assets/img/payment-types/qrcodepay.png';

export default {
    computed: {
        ...mapGetters({
            cardNumberLast4Digits: 'cardPayment/getLast4DigitsFromCardNumber',
            cardHolderName: 'cardPayment/getCardHolderName',
            installments: 'payment/getInstallmentNumberOfPayments',
            installmentPrice: 'payment/getFormattedInstallmentPrice',
            selectedPaymentMethod: 'payment/getSelectedPaymentMethod'
        }),

        paymentMethodImage: self =>
            self.selectedPaymentMethod ? self.selectedPaymentMethod.Image : null,

        isQrCodeDebit: self =>
            self.selectedPaymentMethod &&
            self.selectedPaymentMethod.PaymentType == PaymentTypes.QRCODE_DEBIT,

        isQrCodePay: self =>
            self.selectedPaymentMethod &&
            self.selectedPaymentMethod.PaymentType == PaymentTypes.QRCODE,

        getPaymentTypeIcon: self => QrCodePayIcon,
    }
};
</script>

<style lang="scss" scoped>
.qrcode-overview {

    &__container {
        display: flex;
        align-items: center;
        justify-content: space-between;

    }

    &__info {
        display: flex;
        align-items: center;
    }

    &__icon {
        margin-right: 12px;

        @media screen and (min-width: 1025px) {
            margin-right: 20px;
        }

        img {}
    }

    &__description {
        font-size: 16px;
        font-weight: 500;
        line-height: 16px;
        color: #000;
    }

    &__price {

        p {
            font-size: 16px;
            font-weight: 500;
            line-height: 16px;
            color: #000;
            margin: 0;
        }

        span {}
    }

}
</style>
